/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable arrow-body-style */
import { i18n } from './../../../i18n';
import { isEmpty } from 'lodash-es';
import { SUBMIT_ERROR_STATUS, CREATIVE_SUBMIT_STATUS } from '../const';
import {
  ISubmitErrorInfo,
  ISuccessNameResult,
  IFormatSubmitResult,
  IAsyncSubmitResult,
  IAsyncSubmitResultCreativeBatchResult,
} from '../types';

/**
 * 获取异步创建结果的成功 id 和 失败数据
 * @param batchResult 批次结果
 */
const _getNonAcoCreativeIdsByBatchResult = (batchResult: Record<string, IAsyncSubmitResultCreativeBatchResult>) => {
  const creativeIdsObj = {};
  const creativeErrorObj = {};
  const notCreatedCreativeItems: { name: string; creativeUuid?: string; creativeSnapId?: string }[] = [];

  Object.keys(batchResult).forEach(batchIndex => {
    const creativeItems = batchResult?.[batchIndex]?.creative_items || [];
    const creativeErrorItems = batchResult?.[batchIndex]?.creative_error_items || {};

    creativeItems.forEach(item => {
      if (item.id) {
        // 这里使用每个创意的uuid 来作为标识，避免部分图片广告，部分视频广告，创意下标无法匹配到正确的创意表单
        // 5 single video + 5 single image + 5 single video + 5 singleImage
        // 最终提交时变成 video_list =10, image_list=10, 之前的下标顺序就出问题了

        // 优先使用 creativeUuid 作为标识，否则使用snapId （snapId 只有 1nn 有）
        const key = item.by_creative_async_id || item.by_creative_snap_id;
        creativeIdsObj[key] = {
          creativeUuid: item.by_creative_async_id || '',
          creativeId: item.id || '',
          creativeName: item.name || '',
          creativeSnapId: item.by_creative_snap_id || '',
        };
      } else {
        notCreatedCreativeItems.push({
          name: item.name,
          creativeSnapId: item.by_creative_snap_id,
          creativeUuid: item.by_creative_async_id,
        });
      }
    });

    Object.keys(creativeErrorItems).forEach(cIndex => {
      const creativeItem = creativeItems[cIndex];

      // 优先使用 creativeUuid 作为标识，否则使用snapId
      const key = creativeItem.by_creative_async_id || creativeItem.by_creative_snap_id;
      creativeErrorObj[key] = {
        creativeId: '',
        creativeUuid: creativeItem.by_creative_async_id || '',
        creativeSnapId: creativeItem.by_creative_snap_id || '',
        creativeName: creativeItem.name || '',
        errorList: creativeErrorItems[cIndex],
      };
    });
  });
  return {
    creativeIdsObj,
    notCreatedCreativeItems,
    creativeErrorObj,
  };
};

/** 获取 ACO 报错列表 */
const _getAcoErrorItemsByResult = ({
  acoErrorItems = [],
  adgroupName = '',
  adId = '',
  adgroupSnapId = '',
  creativeSnapId = '',
}) => {
  return acoErrorItems.map(item => {
    return {
      ...item,
      message: item.message || '',
      isAco: true,
      adgroupName,
      adId,
      adgroupSnapId,
      creativeSnapId,
    };
  });
};

/**
 * 格式化提交结果，获取成功的部分，失败的部分
 */
export const getFormatSubmitResult = (data: Partial<IAsyncSubmitResult>): IFormatSubmitResult => {
  const submitResult = data || {};
  const { result } = submitResult as IAsyncSubmitResult;

  const {
    campaign_id: campaignId = '',
    campaign_name: campaignName = '',
    ad_and_creative: adgroupAndCreative = {},
    campaign_error_items: campaignErrorItems = [],
  } = result || {};

  const successResult = {};
  const adgroupFailResult = {};
  const creativeNonAcoFailResult = {};
  const creativeAcoFailResult = {};
  const noCreatedCreativeItemObj = {};

  // 1. 解析 campaign 的报错信息
  const campaignFailResult = campaignErrorItems.map(errorItem => {
    return {
      ...errorItem,
      campaignId,
      campaignName,
    };
  });

  // 2. 解析 adg 和 creative 的报错信息
  const adgroupCount = Object.keys(adgroupAndCreative).length;
  Object.keys(adgroupAndCreative).forEach(adgIndexStr => {
    const adgroupIndex = Number(adgIndexStr);
    const currentAdgroupResult = adgroupAndCreative[adgroupIndex];

    const {
      creative_status: creativeStatus,
      ad_id: adId = '',
      by_ad_snap_id: adgroupSnapId = '',
      ad_name: adName = '',
      is_aco: isAco = false,
      aco_result: acoResult,
      ad_error_items: adErrorItems = [],
      batch_result: batchResult = {},
      all_creative_num: allCreativeNum = 0,
      success_creative_num: successCreativeNum = 0,
    } = currentAdgroupResult || {};

    // 2.1 成功部分，记录 adId 和 对应的 creativeId
    const { creativeIdsObj, creativeErrorObj, notCreatedCreativeItems } =
      _getNonAcoCreativeIdsByBatchResult(batchResult);

    noCreatedCreativeItemObj[adgroupIndex] = notCreatedCreativeItems;

    if (Boolean(adId) || !isEmpty(creativeIdsObj)) {
      successResult[adgroupIndex] = {
        adId,
        adName,
        adgroupSnapId,
        isAco,
        creativeIdsObj,
        notCreatedCreativeItems,
        creativeStatus,
        allCreativeNum,
        successCreativeNum,
        isAllCreativeSuccess: allCreativeNum === successCreativeNum,
      };
    }

    if (creativeStatus === CREATIVE_SUBMIT_STATUS.SOME_FAIL) {
      // 2.2 失败部分，记录报错信息
      const newAdgroupErrorItems = adErrorItems.map(item => ({
        ...item,
        adgroupSnapId,
        adId,
        adName,
        isAco,
        creativeStatus,
      }));
      if (newAdgroupErrorItems?.length > 0) {
        adgroupFailResult[adgroupIndex] = newAdgroupErrorItems;
      }

      // 如果报错不为空，则记录下来，否则忽略
      if (isAco) {
        const { auto_optimizied_material_error_items: acoErrorItems, by_creative_snap_id } = acoResult || {};
        const currentAcoErrorItems = _getAcoErrorItemsByResult({
          adId,
          adgroupSnapId,
          creativeSnapId: by_creative_snap_id,
          acoErrorItems,
          adgroupName: adName,
        });
        if (!isEmpty(currentAcoErrorItems)) {
          creativeAcoFailResult[adgroupIndex] = currentAcoErrorItems;
        }
      } else {
        if (!isEmpty(creativeErrorObj)) {
          creativeNonAcoFailResult[adgroupIndex] = creativeErrorObj;
        }
      }
    }
  });

  const isCampaignFail = campaignFailResult?.length > 0;
  const isAdgroupFail = !isEmpty(adgroupFailResult);
  const isCreativeFail = !isEmpty(creativeNonAcoFailResult) || !isEmpty(creativeAcoFailResult);

  // 成功列表里面存在数据
  const isSomeSuccessAndSomeFail = !isEmpty(successResult);

  return {
    adgroupAndCreative,

    campaignId,
    campaignName,
    adgroupCount,
    successResult,
    isCampaignFail,
    isAdgroupFail,
    isCreativeFail,
    campaignFailResult,
    adgroupFailResult,
    creativeNonAcoFailResult,
    creativeAcoFailResult,
    isSomeSuccessAndSomeFail,
    isAllSuccess: !isCampaignFail && !isAdgroupFail && !isCreativeFail,
    isExistFail: isCampaignFail || isAdgroupFail || isCreativeFail,
    noCreatedCreativeItemObj,
  };
};

/** 获取成功和失败的数量 */
const _getSuccessAndFailCount = (formatSubmitResult: IFormatSubmitResult) => {
  const { successResult = {}, adgroupFailResult = {}, adgroupAndCreative = {} } = formatSubmitResult;

  // adg成功（只要 adg 成功，就算 ad 失败，也算） or 失败的数量
  const adgroupSuccessCount = Object.keys(successResult).length;
  const adgroupFailCount = Object.keys(adgroupFailResult).length;

  // adgroup 下的创意全部成功的数量
  let adgroupAllAdSuccess = 0;

  let creativeSuccessCount = 0;
  let allCreativeCount = 0;
  Object.keys(adgroupAndCreative).forEach(adgIndexStr => {
    const { all_creative_num = 0, success_creative_num = 0 } = adgroupAndCreative?.[adgIndexStr] || {};
    if (all_creative_num === success_creative_num && all_creative_num !== 0) {
      adgroupAllAdSuccess++;
    }
    allCreativeCount += all_creative_num;
    creativeSuccessCount += success_creative_num;
  });

  const creativeFailCount = allCreativeCount - creativeSuccessCount;

  return {
    adgroupAllAdSuccess,
    adgroupFailCount,
    adgroupSuccessCount,
    allCreativeCount,
    creativeSuccessCount,
    creativeFailCount,
  };
};

const DEFAULT_ERROR_TABLE_INFO: ISubmitErrorInfo = {
  title: '',
  desc: '',
  data: [],
  isCanRetry: false,
  isCanFix: false,
  totalMsg: '',
  totalMsgPopoverList: [],
  level: '',
  showExpand: false, // 如果多个 adg，则展示报错信息
};
/** 格式化报错表格的信息 */
const _formatErrorTableInfo = (data = {}) => {
  return Object.assign({}, DEFAULT_ERROR_TABLE_INFO, data);
};

const DEFAULT_ERROR_TABLE_ROW_DATA = {
  name: '-',
  status: SUBMIT_ERROR_STATUS.FAIL,
  statusTitle: '',
  messageList: [],
  isCanRetry: false,
  isCanFix: false,
  adgroupIndex: 0,
  creativeUuid: '',
  creativeSnapId: '',
  children: [],
  allCreativeNames: [],
};

/** 格式化报错表格行数据 */
const _formatErrorTableRowData = (data = {}) => {
  return Object.assign({}, DEFAULT_ERROR_TABLE_ROW_DATA, data);
};

/**
 * 获取创意成功占比描述信息
 * @param formatSubmitResult 格式化的异步创建结果数据
 * @param adgroupIndex adg 下标
 * @returns 成功占比提示文案
 */
const _getCreativeSuccessRateDesc = (formatSubmitResult: IFormatSubmitResult, adgroupIndex: number) => {
  const currentAdgInfo = formatSubmitResult?.adgroupAndCreative?.[adgroupIndex];
  const allCreativeNum = currentAdgInfo?.all_creative_num || 1;
  const successCreativeNum = currentAdgInfo?.success_creative_num || 0;
  if (successCreativeNum > 0) {
    return i18n.t('ttam_creation_submit_table_col_ad_fail_count', {
      now: allCreativeNum - successCreativeNum,
      total: allCreativeNum,
    });
  }
  return '';
};

/**
 * 生成campaign层级报错表格数据
 */
const _generatorCampaignErrorData = (formatSubmitResult: IFormatSubmitResult) => {
  if (isEmpty(formatSubmitResult)) {
    return [];
  }

  const { campaignFailResult = [], campaignName } = formatSubmitResult;
  const messageList = campaignFailResult.map(item => item.message);

  return [
    _formatErrorTableRowData({
      messageList,
      name: campaignName,
      status: SUBMIT_ERROR_STATUS.FAIL,
      statusTitle: i18n.t('ttam_creation_submit_dialog_campaign_fail'),
    }),
  ];
};

/**
 * 生成 adgroup 层级的报错表格数据
 */
const _generatorAdgroupErrorData = (formatSubmitResult: IFormatSubmitResult) => {
  if (isEmpty(formatSubmitResult)) {
    return [];
  }

  const { adgroupFailResult, noCreatedCreativeItemObj } = formatSubmitResult;
  const adgroupErrorList = [];
  Object.keys(adgroupFailResult).forEach(adgIndexStr => {
    const currentAdgFailData = adgroupFailResult[adgIndexStr] || [];
    const adgroupIndex = Number(adgIndexStr) || 0;

    // 类似数量超上限报错，后端把报错信息放到了 adgroup 层级，因此前端应该展示 40/50这种状态提示信息
    const creativeSuccessRateDesc = _getCreativeSuccessRateDesc(formatSubmitResult, adgroupIndex);

    const { adName, adId, adgroupSnapId } = currentAdgFailData[0] || {};
    const errorMsgList = currentAdgFailData.map(item => item.message);

    adgroupErrorList.push(
      _formatErrorTableRowData({
        adgroupIndex,
        adgroupSnapId,
        name: adName,
        id: adId,
        messageList: errorMsgList,
        status: SUBMIT_ERROR_STATUS.FAIL,
        statusTitle: creativeSuccessRateDesc || i18n.t('ttam_creation_submit_table_col_adgroup_fail'),
        allCreativeNames: noCreatedCreativeItemObj[adgIndexStr].map(item => item.name) || [],
      }),
    );
  });

  return adgroupErrorList;
};

/**
 * 获取第一个报错的创意信息
 * 创意只能用 uuid 来作为标识，否则在部分图片部分视频的广告时，匹配创意表单可能不准
 * 多个 adgroup 场景，则需要使用snapId 作为标识，否则可能不准。
 */
const _getFirstErrorInfo = (submitResult: IFormatSubmitResult) => {
  const { creativeNonAcoFailResult, creativeAcoFailResult } = submitResult;
  let adgroupIndex = 0;
  let creativeUuid = '';
  let creativeSnapId = '';

  if (!isEmpty(creativeNonAcoFailResult)) {
    adgroupIndex = Number(Object.keys(creativeNonAcoFailResult)) || 0;

    // 获取第一个报错的创意标识（creativeUuid or creativeSnapId）
    const firstNonAcoKey = Object.keys(creativeNonAcoFailResult[adgroupIndex] || {})[0] || '';
    const firstNonAcoCreativeResult = creativeNonAcoFailResult?.[adgroupIndex]?.[firstNonAcoKey];

    creativeUuid = firstNonAcoCreativeResult?.creativeUuid || '';
    creativeSnapId = firstNonAcoCreativeResult?.creativeSnapId || '';
  } else if (!isEmpty(creativeAcoFailResult)) {
    adgroupIndex = Number(Object.keys(creativeAcoFailResult)) || 0;

    const firstAcoKey = Object.keys(creativeAcoFailResult[adgroupIndex] || {})[0] || '';
    const firstAcoCreativeResult = creativeAcoFailResult?.[adgroupIndex]?.[firstAcoKey];

    creativeUuid = firstAcoCreativeResult?.creativeUuid || '';
    creativeSnapId = firstAcoCreativeResult?.creativeSnapId || '';
  }

  return {
    adgroupIndex,
    creativeUuid,
    creativeSnapId,
  };
};

/**
 * 生成 NonAco 的报错表格数据
 */
const _generatorNonAcoCreativeErrorData = ({ creativeErrorItems, adgroupIndex }) => {
  const currentAdgCreativeErrorItems = creativeErrorItems;
  const nonAcoErrorList = [];
  Object.keys(currentAdgCreativeErrorItems).forEach(key => {
    const currentCreativeErrorItems = currentAdgCreativeErrorItems[key];
    const { creativeName, creativeSnapId, creativeUuid, errorList = [] } = currentCreativeErrorItems || {};
    const messageList = errorList?.map(item => item.message) || [];

    nonAcoErrorList.push(
      _formatErrorTableRowData({
        adgroupIndex,
        creativeUuid,
        creativeSnapId,
        messageList,
        name: creativeName,
        status: SUBMIT_ERROR_STATUS.FAIL,
        statusTitle: i18n.t('ttam_creation_submit_table_col_adgroup_fail'),
        isCanFix: true,
        isAco: false,
      }),
    );
  });

  return nonAcoErrorList;
};

/**
 * 获取创意报错信息
 * 1. 1 个adgroup 则展示报错的 ad 列表
 * 2. 多个adgroup 则展示折叠表格，adgroup 展开才是 ad
 */
const _generatorCreativeErrorData = (formatSubmitResult: IFormatSubmitResult) => {
  if (isEmpty(formatSubmitResult)) {
    return [];
  }

  const firstCreativeInfo = _getFirstErrorInfo(formatSubmitResult);

  const { adgroupCount, creativeNonAcoFailResult, creativeAcoFailResult, adgroupAndCreative } = formatSubmitResult;
  let creativeErrorList = [];
  const firstCreativeUuid = firstCreativeInfo?.creativeUuid;
  const firstCreativeSnapId = firstCreativeInfo?.creativeSnapId;

  // 汇总 NonAco 报错信息
  Object.keys(creativeNonAcoFailResult).forEach(adgroupIndexStr => {
    const currentAdgNonAcoErrorItems = creativeNonAcoFailResult[adgroupIndexStr];
    const adgroupIndex = Number(adgroupIndexStr);
    const currentAdgInfo = adgroupAndCreative[adgroupIndex];

    const currentErrorList = _generatorNonAcoCreativeErrorData({
      creativeErrorItems: currentAdgNonAcoErrorItems,
      adgroupIndex,
    });

    // 大于 1 个 adgroup 场景，报错的话，需要把 ad 错误折叠到 adgroup 内
    if (adgroupCount > 1) {
      const creativeSuccessRateDesc = _getCreativeSuccessRateDesc(formatSubmitResult, adgroupIndex);
      const { all_creative_num = 0, success_creative_num = 0, ad_name = '', ad_id = '' } = currentAdgInfo || {};
      const errorCount = all_creative_num - success_creative_num;
      creativeErrorList.push(
        _formatErrorTableRowData({
          adgroupIndex,
          creativeUuid: firstCreativeUuid,
          creativeSnapId: firstCreativeSnapId,
          name: ad_name,
          adId: ad_id,
          messageList: [i18n.t('ttam_creation_submit_table_col_contain_ad_error', { num: errorCount })],
          statusTitle: creativeSuccessRateDesc || i18n.t('ttam_creation_submit_table_col_adgroup_fail'),
          children: currentErrorList,
        }),
      );
    } else {
      creativeErrorList = creativeErrorList.concat(currentErrorList);
    }
  });

  // 汇总 ACO 报错信息
  Object.keys(creativeAcoFailResult).forEach(adgroupIndexStr => {
    const currentAdgAcoErrorItems = creativeAcoFailResult[adgroupIndexStr];
    const messageList = currentAdgAcoErrorItems.map(item => item.message);
    const { adgroupName = '', adId = '', adgroupSnapId, creativeSnapId } = currentAdgAcoErrorItems?.[0] || {};
    creativeErrorList.push(
      _formatErrorTableRowData({
        adId,
        adgroupSnapId,
        messageList,
        name: adgroupName,
        adgroupIndex: Number(adgroupIndexStr),
        statusTitle: i18n.t('ttam_creation_submit_table_col_adgroup_fail'),
        creativeIndex: 0,
        creativeSnapId,
        isCanFix: true, // ACO的创意也默认可以回去修复
        isAco: true,
      }),
    );
  });
  return creativeErrorList;
};

/**
 * 获取 adgroup 和creative的报错信息
 */
const _generatorAdgroupAndCreativeErrorData = (formatSubmitResult: IFormatSubmitResult) => {
  if (isEmpty(formatSubmitResult)) {
    return [];
  }
  const { adgroupCount, isAdgroupFail, isCreativeFail } = formatSubmitResult;

  let errorList = [];
  if (adgroupCount === 1 && !isAdgroupFail && isCreativeFail) {
    // 1 个 adgroup，且只有创意报错
    errorList = _generatorCreativeErrorData(formatSubmitResult);
  } else {
    // 报错表格都是展示 adgroup 的形态，有多少个 adgroup 展示多少条报错信息，ad 会被 adgroup 折叠起来
    if (isAdgroupFail) {
      errorList = errorList.concat(_generatorAdgroupErrorData(formatSubmitResult));
    }
    if (isCreativeFail) {
      errorList = errorList.concat(_generatorCreativeErrorData(formatSubmitResult));
    }
  }

  return errorList;
};

/**
 * 获取成功创建的名词列表
 * @param formatSubmitResult
 */
const _getSuccessNames = (formatSubmitResult: IFormatSubmitResult) => {
  const { successResult, isSomeSuccessAndSomeFail } = formatSubmitResult || {};

  const successNameResult: Partial<ISuccessNameResult> = {};
  const successAdgroupNameList: string[] = [];
  const successCreativeNameList: string[] = [];

  if (isSomeSuccessAndSomeFail) {
    Object.keys(successResult).forEach(adgIndex => {
      const currentAdgResult = successResult[adgIndex];
      const creativeNameList = Object.keys(currentAdgResult.creativeIdsObj).map(
        key => currentAdgResult.creativeIdsObj[key].creativeName || '',
      );

      if (currentAdgResult.isAllCreativeSuccess) {
        successAdgroupNameList.push(currentAdgResult.adName);
      }
      successCreativeNameList.push(...creativeNameList);

      successNameResult[adgIndex] = {
        adgroupIndex: Number(adgIndex),
        adId: currentAdgResult.adId,
        adgroupSnapId: currentAdgResult?.adgroupSnapId,
        adName: currentAdgResult.adName,
        creativeNameList,
      };
    });
  }

  return {
    successNameResult,
    successAdgroupNameList,
    successCreativeNameList,
  };
};

/**
 * 部分成功、部分失败的报错表格底部提示信息
 * 1. 只有一个 ad 展示成功的创意数量
 * 2. 多个 ad 时，则展示成功的 adg 数量
 **/
const _getSomeSuccessMsg = (formatSubmitResult: IFormatSubmitResult) => {
  const { creativeSuccessCount, adgroupAllAdSuccess } = _getSuccessAndFailCount(formatSubmitResult);
  const { successAdgroupNameList, successCreativeNameList } = _getSuccessNames(formatSubmitResult);

  let successDesc = '';
  let successNameList: string[] = [];

  if (formatSubmitResult.adgroupCount > 1 && adgroupAllAdSuccess > 0) {
    successNameList = successAdgroupNameList;
    successDesc = i18n.t('ttam_creation_submit_dialog_adgroup_fail_other_success', {
      num: adgroupAllAdSuccess,
    }) as string;
  } else if (creativeSuccessCount > 0) {
    successNameList = successCreativeNameList;
    successDesc = i18n.t('ttam_creation_submit_dialog_ad_fail_other_success', { num: creativeSuccessCount }) as string;
  }

  return {
    successDesc,
    successNameList,
  };
};

/**
 * 生成报错表格数据
 * @param submitResult 异步提交结果
 * @param isSnapData 是否为快照数据,快照数据支持返回各层级修改
 */
export const generatorErrorTableData = (submitResult, isSnapData = false): ISubmitErrorInfo => {
  const formatSubmitResult = getFormatSubmitResult(submitResult);
  const { creativeSuccessCount, allCreativeCount, adgroupAllAdSuccess } = _getSuccessAndFailCount(formatSubmitResult);

  const { successDesc, successNameList } = _getSomeSuccessMsg(formatSubmitResult);
  const firstErrorInfo = _getFirstErrorInfo(formatSubmitResult);

  const { isCampaignFail, isAdgroupFail, isCreativeFail, adgroupCount } = formatSubmitResult || {};

  if (isCampaignFail) {
    // 只有 Campaign 报错
    return _formatErrorTableInfo({
      title: i18n.t('ttam_creation_submit_dialog_campaign_fail'),
      desc: i18n.t('ttam_creation_submit_error_dialog_retry_desc'),
      isCanRetry: Boolean(!isSnapData),
      isCanFix: Boolean(isSnapData),
      data: _generatorCampaignErrorData(formatSubmitResult),
      level: 'campaign_fail',
    });
  } else if (isAdgroupFail && !isCreativeFail) {
    // 只有 adgroup层级报错

    let title = i18n.t('ttam_creation_submit_dialog_adgroup_fail_title', {
      failed_num: adgroupCount - adgroupAllAdSuccess,
      published_num: adgroupCount,
    });
    if (adgroupAllAdSuccess === 0) {
      title = i18n.t('ttam_creation_submit_dialog_all_adg_fail_title');
    }
    let isCanRetry = Boolean(!isSnapData);
    let isCanFix = Boolean(isSnapData);
    let showExpand = true;
    let desc = i18n.t('ttam_creation_submit_error_dialog_retry_desc');

    // adgroup下创意超上限，后端报错在了 adgroup 层级，因此这里特殊处理下弹窗标题和修复逻辑
    if (adgroupCount === 1 && creativeSuccessCount > 0) {
      title = i18n.t('ttam_creation_submit_dialog_ad_fail_title', {
        failed_num: allCreativeCount - creativeSuccessCount,
        published_num: allCreativeCount,
      });
      isCanRetry = false;
      isCanFix = true;
      showExpand = false;
      desc = i18n.t('ttam_creation_submit_error_dialog_fix_desc');
    }

    return _formatErrorTableInfo({
      title,
      desc,
      isCanRetry,
      isCanFix,
      showExpand,
      data: _generatorAdgroupAndCreativeErrorData(formatSubmitResult),
      totalMsg: successDesc,
      totalMsgPopoverList: successNameList,
      level: 'adgroup_fail',
    });
  } else if ((isAdgroupFail && isCreativeFail) || (adgroupCount > 1 && isCreativeFail)) {
    // 【极端场景】有 adgroup 层级报错，有创意层级报错, 或者多个 adg，但只有创意报错
    let title = i18n.t('ttam_creation_submit_dialog_adgroup_fail_title', {
      failed_num: adgroupCount - adgroupAllAdSuccess,
      published_num: adgroupCount,
    });
    if (adgroupAllAdSuccess === 0) {
      title = i18n.t('ttam_creation_submit_dialog_all_adg_fail_title');
    }
    return _formatErrorTableInfo({
      title,
      desc: i18n.t('ttam_creation_submit_error_dialog_fix_desc'),
      isCanFix: true, // 存在创意报错，则可以返回 fix
      data: _generatorAdgroupAndCreativeErrorData(formatSubmitResult),
      totalMsg: successDesc,
      totalMsgPopoverList: successNameList,
      level: 'adgroup_and_ad_fail',
      firstErrorInfo,
      showExpand: true,
    });
  } else if (isCreativeFail) {
    let title = i18n.t('ttam_creation_submit_dialog_ad_fail_title', {
      failed_num: allCreativeCount - creativeSuccessCount,
      published_num: allCreativeCount,
    });
    // 如果全部报错，则展示全部报错文案
    if (creativeSuccessCount === 0) {
      title = i18n.t('ttam_creation_submit_dialog_all_ad_fail_title');
    }
    // 只有创意层级报错
    return _formatErrorTableInfo({
      title,
      desc: i18n.t('ttam_creation_submit_error_dialog_fix_desc'),
      isCanFix: true, // 创意层级报错，目前默认返回 fix
      isCanRetry: false,
      data: _generatorAdgroupAndCreativeErrorData(formatSubmitResult),
      totalMsg: successDesc,
      totalMsgPopoverList: successNameList,
      level: 'ad_fail',
      firstErrorInfo,
    });
  } else {
    // 【兜底处理】啥报错也不是，默认展示 campaign 报错
    return _formatErrorTableInfo({
      title: i18n.t('ttam_creation_submit_dialog_campaign_fail'),
      desc: i18n.t('ttam_creation_submit_error_dialog_retry_desc'),
    });
  }
};
